import React, { useState } from "react";
import client from "../lib/api";
import { useSeo } from "../lib/useSeo";
import Layout from "../components/Layout";
import { toast } from "sonner";
import { Send } from "lucide-react";

export default function SubmitTip() {
  const [form, setForm] = useState({ name: "", contact: "", location: "", details: "", media_url: "" });
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  useSeo({ title: "Submit News Tip", description: "Share a news tip with the Rapid24News editorial desk. All submissions are subject to editorial verification." });

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.details.trim()) { toast.error("Name and news details are required."); return; }
    setLoading(true);
    try {
      const r = await client.post("/news-tips", form);
      setSent(true);
      toast.success("Tip submitted for editorial verification.");
    } catch { toast.error("Could not submit. Please try again."); }
    setLoading(false);
  };

  return (
    <Layout>
      <div className="bg-r24-black text-white">
        <div className="max-w-3xl mx-auto px-4 py-10">
          <h1 className="font-head font-bold text-4xl md:text-5xl uc">Submit a <span className="text-r24-red">News Tip</span></h1>
          <p className="text-gray-400 mt-2">अपनी खबर या जानकारी हमें भेजें। सभी सूचनाएँ संपादकीय सत्यापन के अधीन हैं।</p>
        </div>
      </div>
      <section className="max-w-2xl mx-auto px-4 py-10">
        {sent ? (
          <div className="text-center py-16" data-testid="tip-success">
            <div className="w-16 h-16 bg-r24-red rounded-full flex items-center justify-center mx-auto mb-5"><Send className="text-white" /></div>
            <h2 className="font-head font-bold text-2xl">Thank you!</h2>
            <p className="text-gray-600 mt-2">आपकी न्यूज़ टिप मिल गई है। हमारी टीम इसकी जाँच करेगी।</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="tip-form">
            <Field label="Your Name *" value={form.name} onChange={set("name")} testid="tip-name" />
            <Field label="Contact (phone / email)" value={form.contact} onChange={set("contact")} testid="tip-contact" />
            <Field label="Location / District" value={form.location} onChange={set("location")} testid="tip-location" />
            <div>
              <label className="font-head font-semibold uc text-sm">News Details *</label>
              <textarea value={form.details} onChange={set("details")} rows={6} data-testid="tip-details"
                className="w-full border-2 border-gray-300 focus:border-r24-red outline-none px-3 py-2 mt-1" placeholder="क्या हुआ, कहाँ, कब, कौन शामिल है — पूरी जानकारी दें..." />
            </div>
            <Field label="Photo / Video / Document URL (optional)" value={form.media_url} onChange={set("media_url")} testid="tip-media" />
            <button disabled={loading} data-testid="tip-submit" className="bg-r24-red text-white font-bold uc px-8 py-3 hover:bg-r24-reddark disabled:opacity-50">
              {loading ? "Submitting..." : "Submit Tip"}
            </button>
            <p className="text-xs text-gray-500">By submitting, you confirm the information is accurate to the best of your knowledge. Rapid24News verifies all tips before publication.</p>
          </form>
        )}
      </section>
    </Layout>
  );
}

function Field({ label, value, onChange, testid }) {
  return (
    <div>
      <label className="font-head font-semibold uc text-sm">{label}</label>
      <input value={value} onChange={onChange} data-testid={testid}
        className="w-full border-2 border-gray-300 focus:border-r24-red outline-none px-3 py-2 mt-1" />
    </div>
  );
}
